import React from 'react';
import PropTypes from 'prop-types';
import TextQuestion from './questions/text_question';
import TextareaQuestion from './questions/textarea_question';
import RadioQuestion from './questions/radio_question';
import CheckboxQuestion from './questions/checkbox_question';
import DropdownQuestion from './questions/dropdown_question';

const QuestionRenderer = ({ question, value, onChange, error }) => {
  const renderQuestion = () => {
    switch (question.question_type) {
      case 'text':
        return (
          <TextQuestion
            question={question}
            value={value}
            onChange={onChange}
            error={error}
          />
        );
      case 'textarea':
        return (
          <TextareaQuestion
            question={question}
            value={value}
            onChange={onChange}
            error={error}
          />
        );
      case 'radio':
        return (
          <RadioQuestion
            question={question}
            value={value}
            onChange={onChange}
            error={error}
          />
        );
      case 'checkbox':
        return (
          <CheckboxQuestion
            question={question}
            value={value}
            onChange={onChange}
            error={error}
          />
        );
      case 'dropdown':
        return (
          <DropdownQuestion
            question={question}
            value={value}
            onChange={onChange}
            error={error}
          />
        );
      default:
        return <div>Unsupported question type: {question.question_type}</div>;
    }
  };

  return (
    <div className="form-group">
      <label className="form-label">
        {question.question_text}
        {question.required && <span className="required-marker">*</span>}
      </label>
      
      {renderQuestion()}
      
      {error && <div className="field-error">{error}</div>}
    </div>
  );
};

QuestionRenderer.propTypes = {
  question: PropTypes.shape({
    id: PropTypes.number.isRequired,
    question_text: PropTypes.string.isRequired,
    question_type: PropTypes.string.isRequired,
    required: PropTypes.bool.isRequired,
    options: PropTypes.array,
    has_other_option: PropTypes.bool,
    other_option_label: PropTypes.string
  }).isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  onChange: PropTypes.func.isRequired,
  error: PropTypes.string
};

export default QuestionRenderer;